/** Маркер середовища (бренд-бук, розд. 6): видиме слово + прихований опис, не aria-label. */
export const env = {
  envStage: 'ТЕСТ',
  envStageHint: ' — тестове середовище',
  envLocal: 'ЛОКАЛЬНО',
  envLocalHint: ' — локальне середовище',
  envStageNote: 'Тестове середовище: дані несправжні, листи не йдуть людям.',
  envLocalNote: 'Локальне середовище: дані синтетичні, листи йдуть у mailpit.',
} as const;
